

<template>
    <component :is="component" v-if="component" />
</template>

<script>
    export default {
        name: 'DisplayIcon',
        props: ['icon'],
        data() {
            return {
                component: null,
            }
        },
        computed: {
            loader() {
                if (!this.icon) {
                    return null
                }
                return () => import(`./${this.icon}`)
            },
        },
        mounted() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('./HomeIcon')
                })
        }
    }
</script>
